<template>
  <div class="data_chartmain">
    <Header />
    <div class="databox">
      <div class="dataleftbox">
        <el-tree
          ref="tree"
          show-checkbox
          :current-node-key="ids"
          node-key="id"
          :data="cameradata"
          highlight-current
          :default-expand-all="true"
          :props="defaultProps"
          :default-checked-keys="ids"
          @node-click="handleNodeClick"
          @check="handleNodeClick"
        ></el-tree>
      </div>
      <div class="datarightbox">
        <div class="camera-container" v-if="paginatedCameras.length > 0">
          <!-- 单个监控全屏显示 -->
          <div v-if="paginatedCameras.length === 1" class="single-camera">
            <iframe
              v-if="showIframe && ids.includes(paginatedCameras[0].id)"
              :src="paginatedCameras[0].monitorUrl"
              class="myiframe single-iframe"
            />
          </div>

          <!-- 2-4个监控都使用2x2网格 -->
          <div v-else class="camera-grid">
            <iframe
              v-if="showIframe && ids.includes(camera.id)"
              v-for="camera in paginatedCameras"
              :key="camera.id"
              :src="camera.monitorUrl"
              class="myiframe grid-iframe"
            />
          </div>
        </div>

        <!-- 分页控件 -->
        <div class="pagination-container" v-if="totalPages > 1">
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="filteredCameraCount"
            layout="prev, pager, next"
            background
            :pager-count="5"
            class="custom-pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue';
import axios from '@/axios';
import { baseUrl } from '@/axios/baseUrl';

export default {
  name: 'index',
  components: {
    Header,
  },
  data() {
    return {
      isall: true,
      showIframe: true,
      currentPage: 1, // 当前页码
      pageSize: 4, // 每页显示数量
      cameradata: [], // 改为空数组，动态构建
      asstoken: '',
      ids: [],
      monitorList: [], // 存储从API获取的监控数据
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    };
  },
  computed: {
    // 获取当前选中的摄像头数组
    selectedCameras() {
      return this.monitorList.filter((camera) => this.ids.includes(camera.id));
    },

    // 过滤后的摄像头数量
    filteredCameraCount() {
      return this.selectedCameras.length;
    },

    // 总页数
    totalPages() {
      return Math.ceil(this.filteredCameraCount / this.pageSize);
    },

    // 当前页显示的摄像头
    paginatedCameras() {
      const startIndex = (this.currentPage - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.selectedCameras.slice(startIndex, endIndex);
    },
  },
  mounted() {
    this.fetchData();
    var iframeDoc = document.getElementsByClassName('myiframe') || [];
    iframeDoc.forEach((element) => {
      const item = element.contentWindow.document;
      item.body.style.backgroundColor = '#030a2e';
    });
  },
  methods: {
    async fetchData() {
      try {
        const params = {
          page: 1,
          pageSize: 100,
        };
        const res = await axios.post(baseUrl + '/api/monitor/list-page', params);
        console.log('监控列表', res);

        if (res.code === 200) {
          this.monitorList = res.data.list || [];

          // 根据greenhouseName动态构建树形结构
          this.buildCameraTree();

          // 默认选中所有摄像头
          this.ids = this.monitorList.map((item) => item.id);

          // 等待DOM更新完成后，设置树组件的默认选中状态
          this.$nextTick(() => {
            if (this.$refs.tree && this.ids.length > 0) {
              this.$refs.tree.setCheckedKeys(this.ids);
            }
          });
        }
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    // 构建摄像头树形结构
    buildCameraTree() {
      // 按greenhouseName分组
      const groupedData = {};
      this.monitorList.forEach((item, index) => {
        const greenhouseName = item.greenhouseName || '未分组';
        if (!groupedData[greenhouseName]) {
          groupedData[greenhouseName] = [];
        }
        groupedData[greenhouseName].push({
          id: item.id,
          label: item.monitorName || `监控${index + 1}`,
          monitorUrl: item.monitorUrl,
          tenantName: item.tenantName,
          greenhouseName: item.greenhouseName,
        });
      });

      // 构建树形结构
      this.cameradata = Object.keys(groupedData).map((greenhouseName) => ({
        id: `greenhouse_${greenhouseName}`,
        label: greenhouseName,
        children: groupedData[greenhouseName],
      }));
    },

    // 处理分页变化
    handlePageChange(page) {
      this.currentPage = page;
      this.showIframe = false;
      setTimeout(() => {
        this.showIframe = true;
      }, 100);
    },

    handleNodeClick(e) {
      console.log('选择通道', e);
      // 如果点击的是大棚节点，则切换该大棚下所有摄像头的选中状态
      if (e.id && e.id.startsWith('greenhouse_')) {
        const greenhouseName = e.label;
        const greenhouseCameras = this.monitorList.filter((item) => item.greenhouseName === greenhouseName);
        const greenhouseCameraIds = greenhouseCameras.map((item) => item.id);

        // 检查该大棚下所有摄像头是否都已选中
        const allSelected = greenhouseCameraIds.every((id) => this.ids.includes(id));

        if (allSelected) {
          // 如果都已选中，则取消选中
          this.ids = this.ids.filter((id) => !greenhouseCameraIds.includes(id));
        } else {
          // 如果有未选中的，则全部选中
          greenhouseCameraIds.forEach((id) => {
            if (!this.ids.includes(id)) {
              this.ids.push(id);
            }
          });
        }

        this.$refs.tree.setCheckedKeys(this.ids);
        // 重置分页到第一页
        this.currentPage = 1;
        return;
      }

      const dindex = this.ids.indexOf(e.id);
      if (dindex > -1) {
        this.ids.splice(dindex, 1);
      } else {
        this.ids.push(e.id); // 不存在则添加
      }
      this.$refs.tree.setCheckedKeys(this.ids);
      this.showIframe = false;

      // 重置分页到第一页
      this.currentPage = 1;

      setTimeout(() => {
        this.showIframe = true;
      }, 100);
    },
  },
};
</script>

<style scoped lang="less">
@font-face {
  font-family: 'title';
  src: url('../assets/font/title.ttf');
}

.data_chartmain {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #030a2e;
  overflow: hidden;

  .databox {
    margin: 20px;
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    display: flex;

    .dataleftbox {
      width: 300px;
      height: 100%;
      border: 1px solid #99afcc20;
      padding: 20px;
      flex-shrink: 0;
    }

    .datarightbox {
      width: calc(100% - 320px);
      margin-left: 20px;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      overflow-y: auto;
      position: relative;
      padding: 20px;

      .camera-container {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .single-camera {
        width: 100%;
        height: 100%;
      }

      .camera-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
        gap: 20px;
        width: 100%;
        height: 100%;
      }

      .myiframe {
        border: 0;
        border-radius: 8px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        background-color: #000;
      }

      .single-iframe {
        width: 100%;
        height: 100%;
      }

      .grid-iframe {
        width: 100%;
        height: 100%;
      }

      .pagination-container {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        background-color: rgba(3, 10, 46, 0.8);
        padding: 16px 32px;
        border-radius: 8px;
        border: 1px solid #99afcc20;
      }
    }
  }
}

/deep/ .el-tree {
  background-color: transparent;
  color: #fff;
  font-size: 16px;
}

/deep/ .el-tree-node__label {
  font-size: 16px;
}

/* 鼠标移入时改变el-tree节点的背景色 */
/deep/ .el-tree .el-tree-node__content:hover {
  background-color: #2a62ad;
}

/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #2a62ad;
  height: auto;
}

/deep/ .el-tree-node__content {
  padding: 6px 0;
  height: auto;
}

/* 自定义分页样式 */
.custom-pagination {
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2a62ad;
    color: #fff;
  }

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #2a62ad;
  }

  /deep/ .el-pagination.is-background .btn-prev,
  /deep/ .el-pagination.is-background .btn-next {
    background-color: transparent;
    color: #fff;
    border: 1px solid #99afcc20;
  }

  /deep/ .el-pagination.is-background .btn-prev:hover,
  /deep/ .el-pagination.is-background .btn-next:hover {
    background-color: #2a62ad;
    color: #fff;
  }

  /deep/ .el-pagination.is-background .el-pager li {
    background-color: transparent;
    color: #fff;
    border: 1px solid #99afcc20;
    margin: 0 8px;
  }

  /deep/ .el-pagination.is-background .el-pager li:hover {
    background-color: #2a62ad;
    color: #fff;
  }
}
</style>
